module.exports = __webpack_public_path__ + "static/media/iconfont.12d976c2.ttf";